import { NextStepDeciderType } from "./next-step-decider-type.enum";

export abstract class NextStepDeciderConfig {
  deciderType!: NextStepDeciderType
}
